import React from 'react';

import Section from '../components/Section';
import styles from './Videos.module.scss';

const Video = ({ title, youtubeId, className }) => (
  <div className={`${className} ${styles.video}`}>
    <div className={styles.videoRatio}>
      <iframe
        type="text/html"
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${youtubeId}`}
        frameBorder="0"
        title={title}
      />
    </div>
    {/*<div className={styles.videoTitle}>{title}</div>*/}
  </div>
);

const Videos = ({ items, title }) => {
  const className = items && styles[`video${Math.min(6, items.length)}`];
  if (!items || items.length === 0) return <></>;
  return (
    <>
      <Section title={title}>
        <div className={styles.videos}>
          {items.map(event => (
            <Video
              className={className}
              title={event.title}
              youtubeId={event.youtubeId}
              key={event.youtubeId}
            />
          ))}
        </div>
      </Section>
    </>
  );
};

export default Videos;
